import axios from "axios";
import { type VueProductSpecItem } from "./VueProductSpecItem";
import {
    type IProductSpecMultiUpdater,
    type IProductSpecItem,
    apiUrlUpdatedProductListVue,
    mapVueItemToUpdatedRequest,
} from "../..";

export class VueProductSpecMultiUpdater implements IProductSpecMultiUpdater {
    async update(
        specItems: IProductSpecItem[],
        context: string
    ): Promise<void> {
        const items = specItems as VueProductSpecItem[];

        const response = await axios.post(apiUrlUpdatedProductListVue, {
            items: items.map((x) => mapVueItemToUpdatedRequest(x)),
        });
        const updatedItems = response.data;

        for (const item of items) {
            const updatedItem = updatedItems.find(
                (x: any) => x.productId === item.itemId
            );
            if (updatedItem == null) {
                console.warn(
                    "Tried to find item with id " +
                        item.itemId +
                        " but returned undefined"
                );
            }
            item.callbackUpdatedItem(updatedItem, context);
        }
    }
}
